import { Lang } from 'language/translator'

export enum EAccountRole {
  ADMIN = 'ADMIN',
  VIEW = 'VIEW',
  ACCESS_HUB = 'ACCESS_HUB'
}

export type TAccountRoleApi = {
  id: string
  name: EAccountRole
  only_visible_to_homepal: boolean
}

export type PatchSelfBody = {
  data: {
    attributes: {
      first_name: string
      last_name: string
      language?: Lang
    }
  }
}

export type PostAccountBody = {
  data: {
    email: string
    role: string
    first_name: string
    groups: string[]
    last_name: string
    message: string
    company_group_id?: string
    has_access_to_economy_settings?: boolean
    allow_access_to_analyses?: boolean
    organizational_unit_id?: string | null
  }
}

export type PatchAccountBody = {
  data: {
    first_name?: string
    groups?: string[]
    last_name?: string
    role?: string
    title?: string
    is_in_management_group?: boolean
    has_access_to_economy_settings?: boolean
    allow_early_access_export_tables?: boolean
    allow_access_to_analyses?: boolean
    organizational_unit_id?: string | null
  }
}

export type TSignedInAccount = {
  email: string
  first_name: string
  id: string
  is_homepal_user: boolean
  is_homepal_demo_master: boolean
  is_company_group: boolean
  last_name: string
  role: EAccountRole
  phone: string | null
  has_finished_onboarding: boolean
  has_access_to_economy_settings: boolean
  organizational_unit_id: string | null
  organizational_unit_name: string | null
  // properties entered by user
  additional_information: {
    role: string
    preference: string
  } | null
  language: Lang | null
  allow_early_access_export_tables: boolean
  allow_access_to_analyses: boolean
  allow_ai_chat: boolean
  is_in_product_team: boolean
}

export interface TAccount {
  activated_at: Date | null
  company_group_id: string | null
  created_at: Date
  email: string
  first_name: string | null
  id: string
  invite_accepted_at: Date | null
  last_name: string | null
  role: EAccountRole
  has_access_to_economy_settings: boolean
  allow_access_to_analyses: boolean
  organizational_unit_id: string | null
}

/**
 * Used when parsing permissions.
 */
export interface TPermissionAccount {
  accountId: string
  companyGroupId: string | null
  name: string
  email: string
  role: EAccountRole
  allowRevoke: boolean
  owner?: boolean
}

export type UserAgent = 'mac' | 'windows'
